// src/taskService.js
import {
  collection, addDoc, updateDoc, deleteDoc,
  doc, onSnapshot, query, orderBy, serverTimestamp,
} from "firebase/firestore";
import { db } from "./firebase";

const tasksRef = (householdId) => collection(db, "households", householdId, "tasks");

export function subscribeToTasks(householdId, onChange) {
  const q = query(tasksRef(householdId), orderBy("createdAt", "desc"));
  return onSnapshot(q, (snap) => {
    const tasks = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    onChange(tasks);
  });
}

export async function addTask(householdId, task) {
  return addDoc(tasksRef(householdId), {
    ...task,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export async function updateTask(householdId, taskId, updates) {
  const ref = doc(db, "households", householdId, "tasks", taskId);
  return updateDoc(ref, { ...updates, updatedAt: serverTimestamp() });
}

export async function deleteTask(householdId, taskId) {
  const ref = doc(db, "households", householdId, "tasks", taskId);
  return deleteDoc(ref);
}
